// ActivityLog.js

import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { Host } from '../../App';
import './ActivityLog.css';

const Maintenance_ActivityLog = () => {
  const [logs, setLogs] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [filters, setFilters] = useState({
    user: '',
    entity_type: '',
    date_from: '',
    date_to: ''
  });
  const token = window.localStorage.getItem('acessToken');

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    setIsLoading(true);
    try {
      const response = await Axios.get(`https://` + Host + `/maintenance/api/activity-log`, {
        params: { token, ...filters, limit: 100 }
      });
      if (response.data) {
        setLogs(response.data);
      }
    } catch (error) {
      console.error('Error fetching activity logs:', error);
      window.alert('Failed to fetch activity logs');
    } finally {
      setIsLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters(prev => ({ ...prev, [name]: value }));
  };

  const applyFilters = () => {
    fetchLogs();
  };

  const clearFilters = () => {
    setFilters({
      user: '',
      entity_type: '',
      date_from: '',
      date_to: ''
    });
    fetchLogs();
  };

  const getActionBadgeClass = (action) => {
    const classes = {
      'created_request': 'badge-success',
      'updated_ticket': 'badge-info',
      'changed_status': 'badge-warning',
      'assigned': 'badge-primary',
      'completed': 'badge-success',
      'submitted_report': 'badge-info',
      'added_service_type': 'badge-success',
      'updated_service_type': 'badge-info',
      'deleted_service_type': 'badge-danger'
    };
    return classes[action] || 'badge-secondary';
  };

  const getEntityIcon = (entityType) => {
    const icons = {
      'ticket': '🎫',
      'report': '📄',
      'service_type': '🔧'
    };
    return icons[entityType] || '📋';
  };

  return (
    <div className="activity-log-container">
      <div className="activity-header">
        <h1>Activity Log</h1>
        <p>Complete audit trail of all maintenance actions</p>
      </div>

      <div className="filters-section">
        <div className="filter-row">
          <div className="filter-group">
            <label>User</label>
            <input
              type="text"
              name="user"
              className="form-control"
              value={filters.user}
              onChange={handleFilterChange}
              placeholder="Filter by user"
            />
          </div>
          <div className="filter-group">
            <label>Entity Type</label>
            <select
              name="entity_type"
              className="form-control"
              value={filters.entity_type}
              onChange={handleFilterChange}
            >
              <option value="">All</option>
              <option value="ticket">Ticket</option>
              <option value="report">Report</option>
              <option value="service_type">Service Type</option>
            </select>
          </div>
          <div className="filter-group">
            <label>From Date</label>
            <input
              type="date"
              name="date_from"
              className="form-control"
              value={filters.date_from}
              onChange={handleFilterChange}
            />
          </div>
          <div className="filter-group">
            <label>To Date</label>
            <input
              type="date"
              name="date_to"
              className="form-control"
              value={filters.date_to}
              onChange={handleFilterChange}
            />
          </div>
          <div className="filter-actions">
            <button className="btn btn-primary" onClick={applyFilters}>
              Apply
            </button>
            <button className="btn btn-secondary" onClick={clearFilters}>
              Clear
            </button>
          </div>
        </div>
      </div>

      <div className="logs-table-container">
        {isLoading ? (
          <div className="loading-spinner">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <table className="table table-bordered table-hover">
            <thead>
              <tr>
                <th>Timestamp</th>
                <th>User</th>
                <th>Action</th>
                <th>Entity</th>
                <th>Details</th>
              </tr>
            </thead>
            <tbody>
              {logs.length === 0 ? (
                <tr>
                  <td colSpan="5" className="text-center">No activity logs found</td>
                </tr>
              ) : (
                logs.map((log) => (
                  <tr key={log.id}>
                    <td className="log-timestamp">
                      {new Date(log.timestamp).toLocaleString()}
                    </td>
                    <td className="log-user">{log.user}</td>
                    <td>
                      <span className={`badge ${getActionBadgeClass(log.action)}`}>
                        {log.action.replace(/_/g, ' ')}
                      </span>
                    </td>
                    <td className="log-entity">
                      <span className="entity-icon">{getEntityIcon(log.entity_type)}</span>
                      {log.entity_type}: #{log.entity_id}
                    </td>
                    <td className="log-details">
                      {log.details && (
                        <div className="details-toggle">
                          <button
                            className="btn btn-sm btn-link"
                            onClick={() => {
                              const details = document.getElementById(`details-${log.id}`);
                              if (details) {
                                details.classList.toggle('visible');
                              }
                            }}
                          >
                            View Details
                          </button>
                          <div id={`details-${log.id}`} className="details-content">
                            <pre>{JSON.stringify(JSON.parse(log.details), null, 2)}</pre>
                          </div>
                        </div>
                      )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default Maintenance_ActivityLog;